import React from "react";
import "./ModalLanding.scss";

function ModalLanding({ setOpenModal }) {

  return (
    <div className="modalBackground">
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <button
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </button>
        </div>
        <div className="title">
          <h1> COVID-19 Info  </h1>
        </div>
        <div className="body">
          <p>Aufgrund der aktuellen COVID-19 Situation finden alle unsere Trainings unter 3G*-Bedingungen statt.<br />

            Alle Teilnehmer (geimpft, genesen und getestet) haben die Möglichkeit sofort am Training teilzunehmen (Nachweis erforderlich!).<br />

            Sollte es nicht möglich sein selbst einen Test innerhalb von 24 Stunden vor dem Training zu machen, haben Sie die Möglichkeit
            diesen bei uns zu einem Preis von € 5,00 nachzuholen.<br />

            Das Tragen einer FFP2 Maske ist verpflichtend.<br />

            <strong>Sicher Fahren – Sicher gemeinsam im Fahrsicherheitstraining!</strong></p>
        </div>
        <div className="footer">
          <button
            onClick={() => {
              setOpenModal(false);
            }}
            id="cancelBtn"
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalLanding;


// WEBPACK FOOTER //
// ./src/components/ModalLanding.js